module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec05_12f92df1f0e756a0b527c81f6f9f36d9.jpg";